import React from "react";

const NotificationAutomation = () => {
  return <div>Notification</div>;
};

export default NotificationAutomation;
